<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink class="d-flex align-items-center">
        <h6 class="ml-2 mb-0">{{ user.name }} {{ user.lastname }}</h6>
        <div class="c-avatar">
          <img :src="user.profileImageUrl" class="c-avatar-img h-100" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>حساب کاربری</strong>
    </CDropdownHeader>
    <CDropdownItem class="dropdown-text text-sm">
      <router-link :user="user" to="/auth/change-password">
        تغییر رمز عبور
      </router-link>
    </CDropdownItem>
    <CDropdownItem class="dropdown-text text-sm" @click="logout">
      خروج
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      itemsCount: 42,
      user: {},
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    logout() {
      this.$logout();
    },
    async getUser() {
      try {
        const { data } = await axios.get(
          `/${this.$type.toLowerCase()}/${this.$userId}`
        );
        this.user = data;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.c-icon {
  margin-right: 0.3rem;
}
.c-avatar {
  width: 40px;
  height: 40px;
  .c-avatar-img {
    object-fit: cover;
  }
}
.dropdown-text {
  color: #8a93a2;
  a {
    color: inherit;
  }
}
</style>
